import { render } from "./UiLogo.vue?vue&type=template&id=4813cc44&scoped=true&lang=pug"
import script from "./UiLogo.vue?vue&type=script&lang=js"
export * from "./UiLogo.vue?vue&type=script&lang=js"

import "./UiLogo.vue?vue&type=style&index=0&id=4813cc44&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4813cc44"]])

export default __exports__